// Shared orchestration (addendum §10): manual release of a stuck human-call contact lock.
import { z } from 'zod';

export const ReleaseContactLockSchema = z.strictObject({
  /** Why the lock is released by hand (audited, shown in the lock trace). */
  reason: z.string().trim().min(5, 'Escribe el motivo (mínimo 5 caracteres)').max(300),
  /**
   * Required to release a lock whose call the provider reports as still in progress. Without it such a release is
   * refused with 409 `call_live`.
   */
  confirmLive: z.boolean().default(false),
});
export type ReleaseContactLock = z.infer<typeof ReleaseContactLockSchema>;

/** What the provider said about the call when the release was requested. */
export const LOCK_PROVIDER_CHECKS = ['ended', 'live', 'unknown', 'not_checked'] as const;
export const LockProviderCheckSchema = z.enum(LOCK_PROVIDER_CHECKS);
export type LockProviderCheck = z.infer<typeof LockProviderCheckSchema>;

export const ContactLockReleaseSchema = z.object({
  id: z.string(),
  state: z.enum(['active', 'reconciling', 'released']),
  releasedAt: z.string().nullable(),
  releaseReason: z.string().nullable(),
  /** The lock was already released (idempotent repeat): nothing changed. */
  alreadyReleased: z.boolean(),
  providerCheck: LockProviderCheckSchema,
  providerDetail: z.string().nullable(),
});
export type ContactLockRelease = z.infer<typeof ContactLockReleaseSchema>;
